import TreatmentGroupView from './TreatmentGroupView';

export default TreatmentGroupView;
